import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { MerchantDetailAction } from '@/components/widgets/MerchantDetailActions/types/MerchantDetailAction';

export const ActionMessage = ({
  onSubmit,
  currentAction,
  opened,
  setOpened,
  handleClose,
  isLoading,
}: {
  onSubmit: () => void;
  currentAction: MerchantDetailAction;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
  isLoading?: boolean;
}) => {
  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={isLoading} onClick={handleClose}>
            <Text tId={'CANCEL'} />
          </StandardButton>
          <StandardButton loading={isLoading} main onClick={onSubmit}>
            <Text tId={`${currentAction}_BTN`} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant="h3" color="textPrimary">
          <Text tId={currentAction} />
        </Font>
      </Box>
      <Box pt={3}>
        <Font variant={'body2'} color={'textSecondary'}>
          <Text tId={`${currentAction}_TEXT`} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
